module.exports = __webpack_public_path__ + "static/media/forwardIcon.5a30856b.svg";